<template>
  <div class="paper">
    <modal-form modal-id="add-user" animation="fadeInRight">
        <div slot="title">Add New User</div>
        <div slot="form">
          <div class="form-group">
            <div class="row">
              <div class="col-lg-3">Name</div>
              <div class="col-lg-9">
                <input type="text" name="" class="form-control" v-model="addUser['name']">
              </div>
            </div>
            <div class="row">
              <div class="col-lg-3">Username</div>
              <div class="col-lg-9">
                <input type="text" name="" class="form-control" v-model="addUser['username']">
              </div>
            </div>
            <div class="row">
              <div class="col-lg-3">Password</div>
              <div class="col-lg-9">
                <input type="text" name="" class="form-control" v-model="addUser['password']">
              </div>
            </div>
            <div class="row">
              <div class="col-lg-3">Email</div>
              <div class="col-lg-9">
                <input type="email" name="" class="form-control" v-model="addUser['email']">
              </div>
            </div>
            <!--
            <div class="row">
              <div class="col-lg-3">Clients</div>
              <div class="col-lg-9">
                <v-select :options="f.clients" multiple v-model="addUser['clients']" label="name" index="id"></v-select>
              </div>
            </div>
            -->
            <div class="row" v-if="addUser['clients'].length">
              <div class="col-lg-3">Groups</div>
              <div class="col-lg-9">
                <v-select
                  :options="f.groups.filter(g => addUser['clients'].includes(g.client.id))"
                  multiple
                  v-model="addUser['groups']"
                  label="fullName"
                  index="id"
                ></v-select>
              </div>
            </div>
            <!--
            <div class="row">
              <div class="col-lg-3">Roles</div>
              <div class="col-lg-9">
                <v-select :options="userRoles" multiple v-model="addUser['roles']"></v-select>
              </div>
            </div>
            -->
            <div class="row">
              <div class="col-lg-3">Admin</div>
              <div class="col-lg-9">
                <v-select :options="[{val: 'false', txt: 'No'}, {val: 'true', txt: 'Yes'}]" label="txt" index="val" v-model="addUser['admin']"></v-select>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-3">Active</div>
              <div class="col-lg-9">
                <v-select :options="[{val: 'false', txt: 'No'}, {val: 'true', txt: 'Yes'}]"  label="txt" index="val" v-model="addUser['active']"></v-select>
              </div>
            </div>
            <div class="row m-t-md">
              <div class="col-lg-12">
                <button class="btn btn-sm btn-primary" @click="saveUser">Save</button>
              </div>
            </div>
          </div>
        </div>
      </modal-form>
    <div class="ibox-title">
      <h5>Users</h5>
      <button class="btn btn-xs btn-primary pull-right" data-toggle="modal" data-target="#add-user">Add user</button>
    </div>
    <hr />
    <div class="ibox-title">
      <label>Search by (Name or Email)</label><br />
    <input type="text" @change="filterClient"/>
    </div>
    <table class="table table-dark">
    <thead>
    <tr>
        <th>Username</th>
        <th>Name</th>
        <th>Xero Company Name</th>
        <th>Email</th>
        <th>Credits</th>
        <th>Login</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="user in users" :key="user.id">
        <td>
        <i class="fas fa-user green" v-if="user.active" v-tooltip="'Active'"></i>
        <i class="fas fa-user-slash red" v-else v-tooltip="'Blocked'"></i>
        <router-link :to="'/instalinko/client/' + user.id">{{ user.username }}</router-link>
        </td>
        <td>{{ user.name }}</td>
        <td style="width:400px">
          <div v-if="xeroClients.length">
            <v-select :options="xeroClients" label="name" index="id" v-model="user.clients[0]" @input="(val)=>updateXeroClient(val, user)" ></v-select>
          </div>
        </td>
        <td>{{ user.email }}</td>
        <td>{{ (user.wallet.credits||0).toFixed(2) }}
          <!--
          <i v-show="user.admin" class="fa fa-check"></i>
          <i v-show="!user.admin" class="fa fa-remove"></i>
          -->
        </td>
          <!--
        <td>
          <i v-show="user.active" class="fa fa-check"></i>
          <i v-show="!user.active" class="fa fa-remove"></i>
        </td>
          -->
        <td><button @click="()=>login(user)">Login</button></td>
    </tr>
    </tbody>
    </table>
  <hr />
    <div style="background-color: #fff; padding: 10px 10px 20px">
      <div style="float:left">
        <span><strong>Records: </strong>{{ totalPages }}</span>
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
      </div>
      <div style="float:right">
        <strong for="pageSize">Rows:&nbsp;</strong>
        <select id="pageSize" v-model="options.perPage" @change="setPageSize">
          <option v-for="size in pageSizes" :value="size" :key="size">{{ size }}</option>
        </select>
      </div>
      <div style="text-align: center;">
        <div style="display:inline-block"><button @click="prevPage" :disabled="options.page === 1">Previous</button>&nbsp;&nbsp;</div>
        <div style="display:inline-block"><span>&nbsp;{{ options.page }} / {{ Math.ceil(totalPages/options.perPage) }}&nbsp;</span></div>
        <div style="display:inline-block">&nbsp;&nbsp;&nbsp;<button @click="nextPage" :disabled="options.page >= totalPages/options.perPage">Next</button></div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import Modal from '@/components/Helpers/Modal/Form'

// Add User Defaults
const userAddDefaults = {
  name: '',
  username: '',
  password: '',
  email: '',
  clients: [],
  roles: ['client'],
  active: 'false',
  admin: 'false'
}

export default {
  data () {
    return {
      loading: true,
      allUsers: [],
      users: [],
      addUser: {...userAddDefaults},
      filter: {roles: 'client'},
      options: {
        page: 1,
        perPage: 10
      },
      pageSizes: [10, 25, 50],
      totalPages: 0
    }
  },
  beforeMount () {
    this.getUsers()
  },
  components: {
    modalForm: Modal
  },
  methods: {
    async updateXeroClient (val, user) {
      await axios.patch(`/v2/instalinko/users/${user.id}`, {clients: [val].filter(Boolean)})
    },
    async login (user) {
      let {data} = await axios.post(`/v2/instalinko/users/login/${user.id}`)
      window.open('https://app.instalinko.com/dashboard', data.token)
    },
    filterClient (e) {
      const val = e.target.value
      if (val) {
        this.filter = {
          ...this.filter,
          $or: [
            { name: {$regex: `.*${val}.*`, $options: 'i'} },
            { email: {$regex: `.*${val}.*`, $options: 'i'} }
          ]
        }
      } else {
        this.filter = {roles: 'client'}
      }
      this.getUsers()
    },
    async saveUser () {
      const addUser = {...this.addUser}
      try {
        const res = await axios.post('/v2/instalinko/users', addUser)
        this.users = [...this.users, res.data]
        this.$toastr.success('User added successfully', 'Brilliant stuff lad')
      } catch (err) {
        this.$toastr.error(err, 'Unable to create user')
      }
    },
    async getUsers () {
      try {
        let xeroClients = { data: [] }
        try {
          if (process.env.API.endsWith('api.aphexmedia.com')) {
            xeroClients = await axios.get(`/billing/xero/clients`)
          }
        } catch (err) {
          this.$toastr.warning('Xero Clients', 'Unable to get companies')
        }
        this.xeroClients = xeroClients.data.map(obj => { return { ...obj, name: obj.name + ' | ' + obj.customData.xeroContact.name } })
        const res = await axios.get('/v2/instalinko/users', {params: {filter: this.filter, options: this.options}})
        this.totalPages = Number(res.headers['x-total-records'])
        // this.users = res.data
        // this.allUsers = res.data
        const wallets = await axios.get('/v2/instalinko/users/wallets')
        this.users = res.data.map(obj => {
          const wallet = wallets.data.find(item => item.user === obj.id) || {credits: 0}
          let client = xeroClients.data.find(item => obj.clients[0] === item.id) || null
          if (client) {
            client = client.id
          }
          return {...obj, wallet, clients: [client]}
        })
        console.log(this.users)
        this.allUsers = res.data.map(obj => {
          let client = xeroClients.data.find(item => obj.clients[0] === item.id) || null
          if (client) {
            client = client.id
          }
          const wallet = wallets.data.find(item => item.user === obj.id) || {credits: 0}
          return {...obj, wallet, clients: [client]}
        })
      } catch (err) {
        this.$toastr.error(err, 'Unable to get users')
      }
      this.loading = false
    },
    setPageSize (e) {
      this.options.perPage = e.target.value
      this.getUsers()
    },
    nextPage () {
      if (this.options.page < this.totalPages) {
        this.options.page++
        this.getUsers()
      }
    },
    prevPage () {
      if (this.options.page > 1) {
        this.options.page--
        this.getUsers()
      }
    }
  }
}
</script>
<style>
.paper{
  background: #fff;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/Instalinko/Clients.vue